import { render, staticRenderFns } from "./ClvrConfigElement.vue?vue&type=template&id=35797a3a"
import script from "./ClvrConfigElement.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClvrConfigElement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClvrConfigElement.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports